import { connect } from 'react-redux';
import set from 'lodash/set';
import clone from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import View from './AccountAddEditView';
import {
  save,
  updateValidation,
  fetchData,
  updateSupportData,
} from '../../../AdvWorkflow/AdvWorkflowActions';
import {
  setViewId,
  updateDraftAccount,
  saveDraftAccount,
  addDraftAccount,
  setDraftAccount,
} from './AccountsStepActions';
import { OVERVIEW } from './AccountsStepViews';
import { currentClientId, iterator } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../../AccountsWorkflowConstants';
import {
  groupsSelector,
  accountTypesOptionsSelector,
  accountOwnersOptionsSelector,
  accountOwnersGroupsSelector,
  accountDraftSelector,
  nullableAccountTypeOptionSelector,
  nullableAccountOwnerOptionSelector,
  interestRateLabelSelector,
  isMortgageAccountSelector,
  mortgageTypesOptionsSelector,
  nullableMortgageTypeOptionSelector,
  MORTGAGE_ACCOUNT_TYPE,
  isStudentLoanAccountSelector,
} from './AccountAddEditSelector';

import { accountsSelector } from './AccountsStepSelector';
import { onCancel } from './AccountAddEditActions';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  iterator: iterator(state, ownProps),
  account: accountDraftSelector(state, ownProps),

  graphAccounts: accountsSelector(state, ownProps),

  accountTypeOption: nullableAccountTypeOptionSelector(state, ownProps),
  accountOwnerOption: nullableAccountOwnerOptionSelector(state, ownProps),
  mortgageTypeOption: nullableMortgageTypeOptionSelector(state, ownProps),

  groups: groupsSelector(state, ownProps),
  accountOwnersGroups: accountOwnersGroupsSelector(state, ownProps),

  accountTypesOptions: accountTypesOptionsSelector(state, ownProps),
  accountOwnersOptions: accountOwnersOptionsSelector(state, ownProps),
  mortgageTypesOptions: mortgageTypesOptionsSelector(state, ownProps),

  interestRateLabel: interestRateLabelSelector(state, ownProps),

  isMortgageAccount: isMortgageAccountSelector(state, ownProps),
  isStudentLoanAccount: isStudentLoanAccountSelector(state, ownProps),
});
const mapDispatchToProps = dispatch => ({
  onSave: (account, graphAccounts, workflowId, clientId, accountType) => () => {
    if (
      accountType &&
      accountType.value === MORTGAGE_ACCOUNT_TYPE &&
      isNil(account.excludeFromDebtManagementGoal)
    ) {
      // eslint-disable-next-line
      account.excludeFromDebtManagementGoal = true;
    }

    let newAccount;
    let rollbackAccount;
    if (!account.AccountId && !account.frontEndId) {
      newAccount = clone(account);
      newAccount.frontEndId = uuidv4();
      dispatch(addDraftAccount(newAccount, graphAccounts, workflowId, clientId));
    } else {
      rollbackAccount = graphAccounts.find(({ AccountId }) => AccountId === account.AccountId);
      dispatch(saveDraftAccount(account, graphAccounts, workflowId, clientId));
    }

    dispatch(
      save(
        BACKEND_KEY,
        () => {
          dispatch(fetchData(workflowId, clientId, [BACKEND_KEY]));
          dispatch(setViewId(OVERVIEW, workflowId, clientId));
          dispatch(
            updateValidation(set({}, `${BACKEND_KEY}.AccountAddEdit`, []), workflowId, clientId),
          );
        },
        errors => {
          dispatch(
            updateValidation(
              set({}, `${BACKEND_KEY}.AccountAddEdit`, errors),
              workflowId,
              clientId,
            ),
          );
          if (newAccount) {
            dispatch(setDraftAccount(newAccount, workflowId, clientId));
          }

          if (rollbackAccount) {
            dispatch(saveDraftAccount(rollbackAccount, graphAccounts, workflowId, clientId));
          }
        },
        workflowId,
        clientId,
        false,
        null,
        accounts => {
          dispatch(
            updateSupportData(
              {
                [BACKEND_KEY]: {
                  HasYourFamilyStartedSaving: accounts && accounts.length !== 0,
                },
              },
              workflowId,
              clientId,
            ),
          );
        },
      ),
    );
  },
  onCancel: (workflowId, clientId, account, graphAccounts) => () => {
    dispatch(onCancel(workflowId, clientId, account, graphAccounts));
  },

  accountInputChanged: (path, workflowId, clientId) => event => {
    dispatch(updateDraftAccount(set({}, path, event.target.value), workflowId, clientId));
  },
  accountDateChanged: (path, workflowId, clientId) => value => {
    dispatch(updateDraftAccount(set({}, path, value), workflowId, clientId));
  },
  accountSimpleSelectChanged: (path, workflowId, clientId) => value => {
    const extractedValue = set({}, path, (value || {}).value);
    dispatch(
      updateDraftAccount(isNil(extractedValue) ? null : extractedValue, workflowId, clientId),
    );
  },
  accountTypeChanged: (workflowId, clientId) => value => {
    if (value) {
      dispatch(updateDraftAccount(value.extra, workflowId, clientId));
    } else {
      dispatch(updateDraftAccount(set({}, 'AccountType', null), workflowId, clientId));
    }
  },
});

const AccountAddEditContainer = connect(mapStateToProps, mapDispatchToProps)(View);

AccountAddEditContainer.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number),
  workflowId: PropTypes.string.isRequired,
};

export default AccountAddEditContainer;
